<template>
  <div class="spark">
    <!-- <Banner :top="0" /> -->
    <main>
      <div class="bg">
        <img
          class="ios"
          src="~@/assets/newSpark/ios.png"
          @click="downIosFun"
        >
        <a
          :href="androidUrl"
          style="cursor:pointer"
          @click="downloadAndroidFun"
        >
          <img
            :href="androidUrl"
            class="ad"
            src="~@/assets/newSpark/ad.png"
            @click="downloadAndroidFun"
          >
        </a>
      </div>
      <div class="phone_bg">
        <img
          class="ios"
          src="~@/assets/newSpark/ios.png"
          @click="downIosFun"
        >
        <a
          :href="androidUrl"
          style="cursor:pointer"
          @click="downloadAndroidFun"
        >
          <img
            :href="androidUrl"
            class="ad"
            src="~@/assets/newSpark/ad.png"
          >
        </a>
      </div>
    </main>

    <!-- <footer-common /> -->
  </div>
</template>
<script>
// import Banner from '@/components/banner'
// import FooterCommon from '@/components/footer-common'
// eslint-disable-next-line no-unused-vars
import BScroll from 'better-scroll'
import axios from 'axios'
import { mapState } from 'vuex'
import { NEW_API_URL } from '@/urls'

export default {
  components: {
    // Banner,
    // FooterCommon
  },

  data () {
    return {
      clientHeight: document.documentElement.clientHeight,
      clientWidth: document.documentElement.clientWidth,
      scroll: {},
      buttonSrc: require('@/assets/newSpark/Default_button.svg'),
      androidUrl: '',
      num: 0
    }
  },
  computed: {
    ...mapState('Auth', {
      token: 'token'
    })
  },
  created () {
    this.downloadAndroidFun()
  },
  mounted () {
    // set window.body.offsetHeight
    this.clientHeight = document.documentElement.clientHeight
    this.clientWidth = document.documentElement.clientWidth
    // watch onresize
    const _this = this
    window.onresize = function temp () {
      _this.clientHeight = document.documentElement.clientHeight
      _this.clientWidth = document.documentElement.clientWidth
    }
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollX: true,
        click: true
      })
    })
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://s.tb.cn/c.0uYgIF')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.11.98752449TovXsp&id=638402551111&skuId=4611686656829939015&user_id=2210522335310&cat_id=2&is_b=1&rn=c8237f160fea8795029c3f3876107af9'
        )
      }
    },
    openJDFun () {
      if (this._isMobile()) {
        window.open('https://3.cn/-25wtJ4r')
      } else {
        window.open('https://item.jd.com/10112026050173.html')
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    },
    toTaobaoFun () {
      window.open(
        'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.353c1debCzShxX&ft=t&id=622016680358'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
    /* 先去掉固定宽高 */
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1; /* 让背景在最底层，不挡住其他内容 */
    background: url("~@/assets/newSpark/pc-bg.png") no-repeat center center;
    background-size: cover; /* 关键：图片会按比例铺满整个屏幕，不拉伸变形 */

    .ios {
        width: 20%;
        position: absolute;
        top: 64%;
        left: 27%;
        cursor: pointer;
    }

    a{
        width: 20%;
        position: absolute;
        top: 64%;
        left: 53%;
        cursor: pointer;
        transition: opacity 0.2s;
    }
    .ios:hover,
    .ad:hover {
        opacity: 0.8; /* 悬停时稍微变透明 */
    }
}
.phone_bg {
    display: none;
}
@media (max-height: 1204px) {
    .bg {
        display: none;
    }
    .phone_bg {
        display: block;
    }
    .phone_bg {
        /* 先去掉固定宽高 */
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1; /* 让背景在最底层，不挡住其他内容 */
        background: url("~@/assets/newSpark/phone_bg.png") no-repeat center
            center;
        background-size: cover; /* 关键：图片会按比例铺满整个屏幕，不拉伸变形 */
    }
    .ios {
        width: 60%;
        position: absolute;
        top: 57%;
        left: 50%;
        transform: translateX(-50%); /* 向左偏移自身宽度的一半，实现完美居中 */
        cursor: pointer;
    }
    a {
        width: 60%;
        position: absolute;
        top: 71%;
        left: 50%;
        transform: translateX(-50%); /* 向左偏移自身宽度的一半，实现完美居中 */
        cursor: pointer;
    }
}
.spark {
    margin: 0;
    padding: 0;
    font-family: Noto Sans SC;
    .banner_box {
        margin: 0;
        padding: 0;
        // padding-top: 54px;
        background: #e02020;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        min-height: 740px;
        position: relative;
        // @media (max-width: 1024px) {
        //     padding-top: 80px;
        // }

        @media (max-height: 1204px) {
            padding-top: 106px;
        }
        @media (max-height: 748px) {
            padding-top: 54px;
        }
        .img_box {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 1;
            .left {
                .left_txt_box {
                    .left_one {
                        margin-bottom: 32px;
                        width: 387px;
                        img {
                            width: 387px;
                            height: 163px;
                        }
                    }
                    .left_two {
                        margin-bottom: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        & > img:nth-child(1) {
                            // margin-bottom: 16px;
                            margin-right: 16px;
                            width: 166px;
                            height: 36px;
                        }
                        .totaobao {
                            display: flex;
                            width: 152px;
                            height: 44px;
                            margin-left: 10px;
                            border-radius: 22px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #f9cb7c;
                            font-weight: bold;
                            font-size: 14px;
                            color: #400808;
                            img {
                                margin-left: 5px;
                            }
                        }
                        & > img:nth-child(2) {
                            width: 200px;
                            height: 44px;
                        }
                    }
                }

                .left_button_box {
                    display: flex;
                    justify-content: center;
                    position: relative;
                    z-index: 99;
                    img {
                        width: 144px;
                        height: 44px;
                    }
                    > img:nth-child(1) {
                        margin-right: 32px;
                    }
                    p {
                        position: absolute;
                        width: 100%;
                        top: 53px;
                        text-align: center;
                        font-weight: normal;
                        font-size: 12px;
                        color: #fff;
                    }
                }
            }
            .right {
                margin: 0 115px;
                margin-top: -7%;
                width: 640px;
                height: 620px;
            }
            @media (max-width: 1204px) {
                flex-wrap: wrap;
                justify-content: center;
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    .left_txt_box {
                        display: flex;
                        width: 460px;
                        margin-bottom: 48px;
                        .left_one {
                            margin-right: 80px;
                            margin-bottom: 0;
                            img {
                                width: 200px;
                                height: 85px;
                            }
                        }
                        .left_two {
                            display: block;
                            margin-bottom: 0;
                            margin-right: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-wrap: wrap;
                            & > img:nth-child(1) {
                                margin-right: 0px;
                            }
                            .totaobao {
                                width: 180px;
                                margin-bottom: 10px;
                            }
                        }
                    }

                    .left_button_box {
                        width: 100%;
                        // text-align: center;
                        display: flex;
                        justify-content: center;
                        position: relative;
                        z-index: 99;

                        p {
                            position: absolute;
                            width: 100%;
                            top: 53px;
                            text-align: center;
                            font-weight: normal;
                            font-size: 12px;
                            color: #fff;
                        }
                    }
                }
            }
            @media (max-width: 785px) {
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .left_one {
                        margin-right: 80px;
                        margin-bottom: 0;
                    }
                    .left_two {
                        margin-bottom: 0;
                        .totaobao {
                            width: 168px;
                        }
                    }
                }
                .right {
                    margin: 0;
                    margin-top: -7%;
                    width: 520px;
                    height: 504px;
                }
            }
            @media (max-width: 660px) {
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    .left_txt_box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-bottom: 0;
                        .left_one {
                            display: flex;
                            justify-content: center;
                            margin-right: 0;
                            margin-bottom: 34px;
                            width: 100%;
                            img {
                                width: 200px;
                                height: 85px;
                            }
                        }
                        .left_two {
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                            margin-bottom: 0;
                            width: 300px;
                            & img:nth-child(1) {
                                margin-bottom: 14px;
                            }
                            .totaobao {
                                width: 200px;
                            }
                        }
                    }
                }
                .right {
                    margin: 0;
                    margin-top: -7%;
                    width: 360px;
                    height: 349px;
                }
            }
        }
        .sanjiao {
            width: 100%;
            height: 7rem;
            position: absolute;
            left: 0;
            bottom: -1px;
            background: url("~@/assets/newSpark/banner_sanjiao.svg") no-repeat;
            background-size: 100% 100%;
            @media (max-width: 558px) {
                background: url("~@/assets/newSpark/banner_sanjiao_mini.svg")
                    no-repeat;
                width: 100%;
                height: 3.5rem;
                background-size: 100% 100%;
            }
        }
    }
    .badge {
        background: #fff;
        padding-top: 72px;
        display: flex;
        justify-content: center;
        img {
            width: 182px;
            height: 132px;
        }
        img:nth-child(1) {
            margin-right: 128px;
        }
        @media (max-width: 1024px) {
            padding-top: 36px;
        }
        @media (max-width: 558px) {
            img {
                width: 144px;
                height: 108px;
            }
            img:nth-child(1) {
                margin-right: 24px;
            }
        }
    }
    .function_box {
        background: #fff;
        margin-top: -1px;
        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            padding: 80px 0;
            &:nth-child(1) {
                margin-bottom: 46px;
                padding-bottom: 0;
            }
            &:nth-child(2) {
                padding-top: 0;
            }
            @media (max-width: 1024px) {
            }
            @media (max-width: 558px) {
                padding: 64px 0;
                &:nth-child(1) {
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
                &:nth-child(2) {
                    margin-bottom: 0;
                    padding-top: 0;
                }
            }
            .item {
                width: 210px;
                text-align: center;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                font-size: 16px;
                font-weight: bold;
                h4 {
                    line-height: 30px;
                    color: #101010;
                }
                p {
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 20px;
                    color: #878787;
                }
                img {
                    width: 40px;
                    height: 40px;
                }
                & > * {
                    width: 100%;
                }
                @media (max-width: 1024px) {
                    width: 182px;
                }
                @media (max-width: 558px) {
                    width: 175px;
                    margin-bottom: 28px;
                }
            }
        }
    }
    .fun_img_box {
        background: #e02020;
        .item {
            color: #fff;
            text-align: center;
            .fun_txt {
                // text-align: center;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                padding: 32px;

                h3 {
                    color: #fff;
                    width: 100%;
                    font-size: 40px;
                    font-weight: 800;
                }
                p {
                    font-family: Noto Sans SC;
                    max-width: 700px;
                    font-size: 16px;
                    font-weight: normal;
                }
                @media (max-width: 558px) {
                    h3 {
                        font-size: 32px;
                    }
                    p {
                        font-size: 12px;
                    }
                }
            }
            .fun_img {
                img {
                    width: 100%;
                }
            }
        }
    }
    .check_box {
        padding: 80px 20px;
        box-sizing: border-box;
        background: #fff;
        color: #101010;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        // width:630px;
        .check_left {
            margin-right: 40px;
            @media (max-width: 744px) {
                margin-right: 0px;
                margin-bottom: 48px;
            }
        }
        .check_left,
        .check_right {
            & > div:nth-last-child(1) {
                margin-bottom: 0px;
            }
        }
        .check_item {
            width: 332px;
            margin-bottom: 48px;
            .check_title {
                font-size: 16px;
                padding-bottom: 12px;
                border-bottom: 1px solid #b8b8b8;
                font-weight: 800;
            }
            ul {
                .check_li {
                    padding-top: 12px;
                    font-size: 12px;
                    display: flex;
                    justify-content: space-between;
                    div {
                        flex: 1;
                        h5 {
                            font-weight: 600;
                            padding-bottom: 5px;
                        }
                        p {
                            font-weight: 400;
                            color: #878787;
                        }
                    }
                }
            }
        }
    }
    .time_box {
        padding: 80px 0;
        // text-align:center;
        display: flex;
        justify-content: center;
        color: #fff;
        background: #101010;
        .time_content {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            background: url("~@/assets/newSpark/time_bg.png") no-repeat;
            background-size: 100%;
            width: 100%;
            padding: 0 0 0 32px;
            @media (max-width: 704px) {
                background: url("~@/assets/newSpark/time_bg1.png") no-repeat;
                background-size: 100%;
            }
            .time_content_box {
                width: 100%;
                max-width: 704px;
                & > * {
                    padding-right: 32px;
                }
                h2 {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    img {
                        width: 237px;
                        height: 41px;
                    }
                }
                h3 {
                    width: 100%;
                    font-size: 26px;
                    letter-spacing: 0.4em;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 64px;
                }
                .time_txt {
                    margin-bottom: 66px;
                    p {
                        font-size: 16px;
                        text-align: justify;
                        &:nth-child(1) {
                            margin-bottom: 30px;
                        }
                    }
                }
                .wrapper {
                    padding-right: 0;
                }
            }
        }
    }
}
.left_button_box {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 99;

    img {
        width: 144px;
        height: 44px;
    }
    > img:nth-child(1) {
        margin-right: 32px;
    }
    p {
        position: absolute;
        width: 100%;
        top: 53px;
        text-align: center;
        font-weight: normal;
        font-size: 12px;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark.vue